export var WordSwitchOperation;
(function (WordSwitchOperation) {
    WordSwitchOperation[WordSwitchOperation["Add"] = 0] = "Add";
    WordSwitchOperation[WordSwitchOperation["Subtract"] = 1] = "Subtract";
    WordSwitchOperation[WordSwitchOperation["SetConstant"] = 2] = "SetConstant";
})(WordSwitchOperation || (WordSwitchOperation = {}));
